import axios from "./axios";

export async function fetchHrSettings() {
  return axios.get("/hr/settings").then((response) => response.data);
}

export async function updateHrSettings(payload) {
  return axios
    .put("/hr/settings", { hr_setting: payload })
    .then((response) => response.data);
}
